<template>
  <v-app id="inspire">
    <v-app-bar
      fixed
      :color="this.$vuetify.theme.themes.light.barraSuperior"
      dark
    >
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon v-if="$mostraLogoBarra == 'TRUE' && !isIcon">
        <v-img
          height="40"
          :src="`logo-pequeno.png`"
          :lazy-src="`logo-pequeno.png`"
          contain
        >
          <template v-slot:placeholder>
            <v-layout fill-height align-center justify-center ma-0>
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-layout>
          </template>
        </v-img>
      </v-app-bar-nav-icon>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-main class="pt-14">
      <v-container fluid fill-height grid-list-xl>
        <v-layout align-center justify-center>
          <v-flex>
            <v-layout row wrap align-content-start justify-center fill-height>
              <v-flex xs12 sm8 md4 lg4 xl3 class="pa-3">
                <v-card
                  class="d-flex justify-center align-center flex-column mx-auto elevation-2"
                >
                  <v-img
                    height="200px"
                    width="50%"
                    v-if="$mostraLogoLogin == 'TRUE'"
                    :src="`logo-grande.png`"
                    contain
                  >
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                  <h2 class="pt-2">Venha fazer parte do nosso time!</h2>
                  <v-card-text class="text-justify" style="font-size: 20px">
                    <p v-if="isIcon">
                      São 50 anos de experiência e know-how em soluções
                      industriais. Composto por pessoas realizadas e
                      comprometidas para desenvolver sempre mais a qualidade dos
                      nossos produtos e serviços.
                    </p>
                    <p v-else-if="isAGL">
                      Para a AGL Brasil, ter seus objetivos, metas e crescimento
                      alcançados são aspectos muito importantes, assim como os
                      valores que nos permeiam, impactando positivamente na
                      qualidade de vida das pessoas. Nossas bases sólidas nos
                      tornaram grandes e referência no mercado de tecnologia.
                      <br />
                      CONHEÇA OS MOTIVOS QUE NOS MOVEM
                      <br />
                      1. Fazer diferença na vida das pessoas
                      <br />
                      2. Buscar pelo novo
                      <br />
                      3. Desenvolvimento Profissional
                      <br />
                      4. Ser uma marca reconhecida
                      <br />
                      Se identificou? Venha fazer parte do nosso time.
                    </p>
                    <p v-else>
                      A {{ this.$clienteNomeFantasia }} precisa de muitos
                      profissionais para continuar o seu desenvolvimento e
                      agora, você pode ser um deles!
                    </p>
                  </v-card-text>
                  <v-card-text
                    v-if="$mostraFrasePCD == 'TRUE'"
                    style="font-size: 20px; text-justify"
                    >Dispomos de vagas exclusivas para PCD, consulte
                    abaixo.</v-card-text
                  >
                  <v-card-actions class="pa-4">
                    <v-btn
                      v-if="$mostraBotaoVagas == 'TRUE'"
                      block
                      color="primary"
                      :class="this.$vuetify.theme.themes.light.buttonText"
                      @click="consultarVagas"
                      >Consultar vagas disponíveis</v-btn
                    >
                  </v-card-actions>
                </v-card>

                <v-card class="mt-4" v-if="$avisoHomeTitulo">
                  <h3 class="pt-2">{{ $avisoHomeTitulo }}</h3>

                  <v-list dense class="pt-4">
                    <v-list-item
                      v-for="(aviso, i) in $avisoHomeConteudo"
                      :key="i"
                      class="px-2"
                    >
                      <v-list-item-icon class="mx-2">
                        <v-icon color="black" size="12">mdi-square</v-icon>
                      </v-list-item-icon>

                      <p
                        class="text-wrap text-left font-weight-medium text-subtitle-2"
                      >
                        {{ aviso }}
                      </p>
                      <!-- <v-list-item-content>
                        
                        <v-list-item-title v-text="aviso" class="text-wrap text-left"></v-list-item-title>
                      </v-list-item-content>-->
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-flex>

              <v-flex xs12 sm8 md4 lg3 xl3 class="mb-2 align-self-center">
                <cgi-login @home="setComponent"></cgi-login>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
    <cgi-footer />
  </v-app>
</template>

<script>
import VagasEmpregoVue from "./VagasEmprego.vue";
import CardLoginVue from "./CardLogin.vue";
import Footer from "./Footer.vue";
import HomeVue from "./Home.vue";
export default {
  components: {
    "cgi-login": CardLoginVue,
    "cgi-footer": Footer,
  },
  mounted() {
    if (
      localStorage.getItem("codPessoa") !== null &&
      localStorage.getItem("senha") !== null
    ) {
      this.$emit("home", HomeVue);
    }
  },
  methods: {
    consultarVagas() {
      this.$emit("home", VagasEmpregoVue);
    },
    setComponent(val) {
      this.$emit("home", val);
    },
  },
  props: {
    source: String,
  },
  computed: {
    appVersion() {
      return this.$store.getters.appVersion;
    },
    isIcon() {
      return process.env.VUE_APP_CLIENTE === "ICON";
    },
    isAGL() {
      return process.env.VUE_APP_CLIENTE === "AGL";
    },
  },
};
</script>